import { Component } from '@angular/core';
import {CguTypeEnum} from '../../../shared/components/conditions-generales/cgu.model';

@Component({
    selector: 'jhi-condition-generale',
    templateUrl: './condition-generale.component.html'
})
export class ConditionGeneraleComponent {
    cguTypeEnum = CguTypeEnum.CGU;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/condition-generale/condition-generale.component.ts